import React, { useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
} from "reactstrap";

import { putPlan, postPlan } from "../../helpers/backend_helper";
import Validate from "./Validate";

const AddUpdModal = ({
  modal,
  setModal,
  plan,
  setPlan,
  onFinishModalAction,
}) => {
  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setModal({ ...modal, show: false, update: false });
  };

  const handlerOnChange = (value, name) => {
    setPlan((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const save = () => {
    setErrors([]);
    const validate = Validate(plan);
    if (validate != undefined) {
      setErrors(validate);
      setLoading(false);
      return;
    }

    setLoading(true);

    if (modal.update) {
      putPlan(plan).then((response) => {
        responseAction(response);
      });
    } else {
      postPlan(plan).then((response) => {
        responseAction(response);
      });
    }
  };

  const responseAction = (response) => {
    if (response.status) {
      handleClose();
      onFinishModalAction();
    }

    setLoading(false);
  };

  return (
    <div>
      <Modal isOpen={modal.show}>
        <ModalHeader className="bg-primary">
          {modal.update ? "Editar " : "Agregar "}Plan
        </ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-sm-12">
              <label className="form-label">Nombre:</label>
              <input
                className="form-control"
                name="name"
                type="text"
                onChange={(e) => handlerOnChange(e.target.value, "name")}
                value={plan.name}
              />
              {errors && (
                <div className="form-text text-danger">
                  {errors.name && errors.name[0]}
                </div>
              )}
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={save} disabled={loading}>
            {loading && <Spinner size="sm"></Spinner>}
            Guardar
          </Button>{" "}
          <Button color="secondary" onClick={handleClose}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default AddUpdModal;
